import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    user_props: null,
    custom_claims: null,
    location: null,
    treatment_plan: null,
    pat_num: null,
    pat_name: null,
    appointment: null,
    encounter: null,
  },
  getters: {
    user: state => state.user,
    user_props: state => state.user_props,
    custom_claims: state => state.custom_claims,
    location: state => state.location,
    treatment_plan: state => state.treatment_plan,
    pat_num: state => state.pat_num,
    pat_name: state => state.pat_name,
    appointment: state => state.appointment,
    encounter: state => state.encounter,
  },
  mutations: {
    ...vuexfireMutations,
    UPDATE_USER (state, user_payload) {
      state.user = user_payload;
    },
    RESET_STATE (state, account_payload) {
      state.user = null;
      state.user_props = null;
      state.custom_claims = null;
      state.location = null;
      state.treatment_plan = null;
      state.pat_name = null;
      state.pat_num = null;
      state.appointment = null;
    },
    UPDATE_CUSTOM_CLAIMS (state, custom_claims_payload) {
      state.custom_claims = custom_claims_payload;
    },
    UPDATE_LOCATION (state, location_payload) {
      state.location = location_payload;
    },
    UPDATE_TREATMENT_PLAN (state, treatment_plan_payload) {
      state.treatment_plan = treatment_plan_payload;
    },
    CLEAR_TREATMENT_PLAN (state) {
      state.treatment_plan = null;
    },
    UPDATE_PAT_NUM (state, pat_num_payload) {
      state.pat_num = pat_num_payload;
    },
    CLEAR_PAT_NUM (state) {
      state.pat_num = null;
    },
    UPDATE_PAT_NAME (state, pat_name_payload) {
      state.pat_name = pat_name_payload;
    },
    CLEAR_PAT_NAME (state) {
      state.pat_name = null;
    },
    UPDATE_APPOINTMENT (state, appointment_payload) {
      state.appointment = appointment_payload;
    },
    CLEAR_APPOINTMENT (state) {
      state.appointment = null;
    },
    UPDATE_ENCOUNTER (state, encounter_payload) {
      state.encounter = encounter_payload;
    },
    CLEAR_ENCOUNTER (state) {
      state.encounter = null;
    },
  },
  actions: {
    updateUser (context, user_payload) {
      context.commit('UPDATE_USER', user_payload)
    },
    resetState (context) {
      context.commit('RESET_STATE')
    },
    updateCustomClaims (context, custom_claims_payload) {
      context.commit('UPDATE_CUSTOM_CLAIMS', custom_claims_payload)
    },
    // only id and name are kept in state
    updateLocation (context, location_payload) {
      const location = location_payload
        ? { id: location_payload.id, name: location_payload.name }
        : null;
      context.commit('UPDATE_LOCATION', location)
    },
    updateTreatmentPlan (context, treatment_plan_payload) {
      context.commit('UPDATE_TREATMENT_PLAN', treatment_plan_payload)
    },
    clearTreatmentPlan (context) {
      context.commit('CLEAR_TREATMENT_PLAN')
    },
    updatePatNum (context, pat_num_payload) {
      context.commit('UPDATE_PAT_NUM', pat_num_payload)
    },
    clearPatNum (context) {
      context.commit('CLEAR_PAT_NUM')
    },
    updatePatName (context, pat_name_payload) {
      context.commit('UPDATE_PAT_NAME', pat_name_payload)
    },
    clearPatName (context) {
      context.commit('CLEAR_PAT_NAME')
    },
    updateAppointment (context, appointment_payload) {
      context.commit('UPDATE_APPOINTMENT', appointment_payload)
    },
    clearAppointment(context) {
      context.commit('CLEAR_APPOINTMENT')
    },
    updateEncounter (context, encounter_payload) {
      context.commit('UPDATE_ENCOUNTER', encounter_payload)
    },
    clearEncounter(context) {
      context.commit('CLEAR_ENCOUNTER')
    },
    // bind state to firebase using vuexfire
    // Firestore /users collection
    setUserPropsRef: firestoreAction((context, documentRef) => {
      // context contains all original properties like commit, state, etc
      // and adds `bindFirestoreRef` and `unbindFirestoreRef`
      // we return the promise returned by `bindFirestoreRef` that will
      // resolve once data is ready
      return context.bindFirestoreRef('user_props', documentRef)
    }),
  }
})
